import { useEffect, useRef, useState } from 'react';

/**
 * Hook personalizzato che osserva quando un elemento entra nel viewport.
 * Utile per attivare animazioni solo quando l'utente scrolla fino alla sezione.
 */
export const useScrollReveal = (threshold = 0.15) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(element); // Anima solo una volta
        }
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [threshold]);

  return { ref, isVisible };
};

export default useScrollReveal;

